import { Button as ButtonAnt, Modal as ModalAnt } from 'antd';

import ModalHeader from '../../../../components/generic/ModalHeader';
import { Loading } from '../../../../components';
import { ApolloError } from '@apollo/client';
import FetchError from '../../../../components/generic/FetchError';

type DeleteMaterialProps = {
  isDeleteMaterialModalOpen: boolean;
  handleCloseMaterialDeleteModal: () => void;
  onDelete: () => void;
  loading: boolean;
  error: ApolloError | undefined;
};

const DeleteMaterial = ({
  isDeleteMaterialModalOpen,
  handleCloseMaterialDeleteModal,
  onDelete,
  loading,
  error,
}: DeleteMaterialProps) => {
  return (
    <ModalAnt
      title={<ModalHeader title="DELETE MATERIAL" />}
      open={isDeleteMaterialModalOpen}
      onCancel={handleCloseMaterialDeleteModal}
      footer={[
        <div className="m-4 flex justify-end gap-4">
          <ButtonAnt key="back" onClick={handleCloseMaterialDeleteModal}>
            Cancel
          </ButtonAnt>
          <ButtonAnt key="submit" type="primary" danger onClick={onDelete}>
            Delete
          </ButtonAnt>
        </div>,
      ]}
      className="custom-modal"
      centered
    >
      {loading ? (
        <Loading />
      ) : (
        <p>Are you sure you want to delete this entry?</p>
      )}
      {error && <FetchError error={error.message} />}
    </ModalAnt>
  );
};

export default DeleteMaterial;
